import React from "react";
import ArrowDropDownIcon from "@mui/icons-material/ArrowDropDown";
import { IconButton } from "@mui/material";

const showMoreArrow = ({ rowControls, setRowControls, rowNumber }) => {
    if (rowNumber === 1) {
        if (
            JSON.stringify(rowControls) ===
            JSON.stringify({
                row1: true,
                row2: false,
                row3: false,
                row4: false,
                row5: false,
                row6: false,
            })
        )
            return (
                <IconButton
                    aria-label="view-neglible-data"
                    style={{ marginLeft: "50%", marginTop: "16px", width: "40px" }}
                    onClick={() =>
                        setRowControls({
                            row1: true,
                            row2: true,
                            row3: false,
                            row4: false,
                            row5: false,
                            row6: false,
                        })
                    }
                >
                    <ArrowDropDownIcon />
                </IconButton>
            );
        return null;
    }
    if (rowNumber === 2) {
        if (
            JSON.stringify(rowControls) ===
            JSON.stringify({
                row1: true,
                row2: true,
                row3: false,
                row4: false,
                row5: false,
                row6: false,
            })
        )
            return (
                <IconButton
                    aria-label="view-neglible-data"
                    style={{ marginLeft: "50%", marginTop: "16px", width: "40px" }}
                    onClick={() =>
                        setRowControls({
                            row1: true,
                            row2: true,
                            row3: true,
                            row4: false,
                            row5: false,
                            row6: false,
                        })
                    }
                >
                    <ArrowDropDownIcon />
                </IconButton>
            );
        return null;
    }
    if (rowNumber === 3) {
        if (
            JSON.stringify(rowControls) ===
            JSON.stringify({
                row1: true,
                row2: true,
                row3: true,
                row4: false,
                row5: false,
                row6: false,
            })
        )
            return (
                <IconButton
                    aria-label="view-neglible-data"
                    style={{ marginLeft: "50%", marginTop: "16px", width: "40px" }}
                    onClick={() =>
                        setRowControls({
                            row1: true,
                            row2: true,
                            row3: true,
                            row4: true,
                            row5: false,
                            row6: false,
                        })
                    }
                >
                    <ArrowDropDownIcon />
                </IconButton>
            );
        return null;
    }
    if (rowNumber === 4) {
        if (
            JSON.stringify(rowControls) ===
            JSON.stringify({
                row1: true,
                row2: true,
                row3: true,
                row4: true,
                row5: false,
                row6: false,
            })
        )
            return (
                <IconButton
                    aria-label="view-neglible-data"
                    style={{ marginLeft: "50%", marginTop: "16px", width: "40px" }}
                    onClick={() =>
                        setRowControls({
                            row1: true,
                            row2: true,
                            row3: true,
                            row4: true,
                            row5: true,
                            row6: false,
                        })
                    }
                >
                    <ArrowDropDownIcon />
                </IconButton>
            );
        return null;
    }
    if (rowNumber === 5) {
        if (
            JSON.stringify(rowControls) ===
            JSON.stringify({
                row1: true,
                row2: true,
                row3: true,
                row4: true,
                row5: true,
                row6: false,
            })
        )
            return (
                <IconButton
                    aria-label="view-neglible-data"
                    style={{ marginLeft: "50%", marginTop: "16px", width: "40px" }}
                    onClick={() =>
                        setRowControls({
                            row1: true,
                            row2: true,
                            row3: true,
                            row4: true,
                            row5: true,
                            row6: true,
                        })
                    }
                >
                    <ArrowDropDownIcon />
                </IconButton>
            );
        return null;
    }
    if (rowNumber === 6) {
        return null;
    }
    return null;
};

export default showMoreArrow;
